module.exports = __webpack_public_path__ + "img/complete-form.4c4e4c6.svg";